module.exports = wp.compose;